import { ReactNode } from 'react';
import { LabelSanitizer } from '../../../../../../../utils/labelSanitization';
import { DescriptorCleanedLabel, ImportTableDescriptorType } from '../../../../types';
import _ from 'lodash';
import diff from 'fast-diff';

export function getCleanedLabels(descriptors: ImportTableDescriptorType[]) {
    const result: DescriptorCleanedLabel[] = [];
    // Loop through each descriptor in the map
    descriptors.forEach((d) => {
        // Skip descriptors without a label
        if (!d.label) {
            return;
        }
        const cleanedLabel = LabelSanitizer.sanitizeLabel(d.label);
        const diffOperations = diff(d.label, cleanedLabel);
        if (!diffOperations.some(([op]) => op === diff.DELETE)) {
            return;
        }

        let highlightedLabel: ReactNode[] = [];

        diffOperations.forEach(([operation, text]) => {
            if (operation === diff.DELETE) {
                highlightedLabel.push(
                    <span
                        key={_.uniqueId()}
                        className={`normalized-label_removed-part ${text === ' ' ? 'bg-red white-space-pre' : ''}`}
                    >
                        {text}
                    </span>
                );
            } else {
                highlightedLabel.push(<span key={_.uniqueId()}>{text}</span>);
            }
        });

        result.push({
            descriptorId: d.id,
            cleanLabel: LabelSanitizer.sanitizeLabel(d.label),
            include: true,
            highlightedLabel: highlightedLabel,
        });
    });
    return result;
}
